import { LoadingContent } from "../../components/common/Loading/loadingContent";

/** Componente de página de carga. */
export const LoadingPage = () => {
  return <LoadingContent />;
};